import { Dayjs } from 'dayjs';

/** `hero` — כרטיס ממורכז בראש הדף. `spotlight` — הקוביות הזוהרות. `catalog` — הגריד הרגיל. */
export type FeatureSection = 'hero' | 'spotlight' | 'catalog';

export type PricingKind = 'included' | 'free-trial' | 'paid' | 'contact';

export interface IFeaturePricing {
    kind: PricingKind;
    label: string;
    /** שורת הבהרה קטנה מתחת לתג המחיר (למשל "לפי מספר משתמשים") */
    note?: string;
    /** מחיר ישן עם קו מחיקה — למשל `₪199` */
    wasPrice?: string;
}

export interface IFeatureGoalPath {
    /** כותרת קצרה מעל הצ'יפים. ברירת מחדל: "המטרה" */
    label?: string;
    /** שלבי האחוזים, בסדר עולה. האחרון מודגש — למשל `90%!` */
    steps: string[];
    caption?: string;
}

export interface IFeature {
    id: string;
    section: FeatureSection;
    title: string;
    shortDescription: string;
    description: string;
    /** תג קטן על התמונה — "AI", "וואטסאפ", "ליקוט"… */
    badge: string;
    /** צ'יפים לסינון בגריד היכולות */
    tags: string[];
    /** שם קובץ התמונה ב-S3 (רק שם — לא URL). למשל `ai-assistant.webp` */
    imageFile?: string;
    /** שם קובץ סרטון ההדגמה ב-S3. כשקיים — מוצג נגן בחלון הפירוט */
    videoFile?: string;
    /** שם קובץ פוסטר לסרטון. ברירת מחדל: `imageFile` */
    posterFile?: string;
    pricing: IFeaturePricing;
    /** מסלול יעד ויזואלי — למשל 10% → 20% → 50% → 90% */
    goalPath?: IFeatureGoalPath;
    /** צ'יפי יתרונות על הכרטיס — לא לסינון בקטלוג */
    promoChips?: string[];
    /** "מה מקבלים" — נקודות מפתח */
    highlights: string[];
    /** "איך מפעילים" — צעדים ממוספרים */
    instructions?: string[];
    /** נתיב פנימי כשהיכולת כבר פעילה אצל הלקוח */
    ctaPath?: string;
    /** לינק חיצוני להתרשמות — נפתח בטאב חדש ("לצפייה בדוגמה") */
    demoUrl?: string;
    releasedAt?: Date | Dayjs;
    /** `false` — לא מוצג בדף. ברירת מחדל: מוצג */
    show?: boolean;
    /** מציג תג "בקרוב" על הכרטיס ובחלון הפירוט */
    comingSoon?: boolean;
    /** מציג תג "בפיילוט" */
    pilot?: boolean;
    /** כותרת מבצע מעל הכרטיס — למשל "מבצע לתקופת החגים" */
    promoHeader?: string;
}

export const isAiFeature = (feature: Pick<IFeature, 'tags'>) => feature.tags.includes('AI');

export interface IUpdate {
    title: string;
    description?: string;
    date: Date | Dayjs;
    /** מקשר את העדכון ליכולת — לחיצה תפתח את חלון הפירוט שלה */
    featureId?: string;
}
